<template>
    <div class="tb_st03 mt-10 pc-visible">
        <div class="thead">
            <table>
                <caption>리스트헤더</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead>
                <tr>
                    <th>동명</th>
                    <th>탁도<br />NTU</th>
                    <th>잔류염소<br />mg/L</th>
                    <th>수소이온<br />pH</th>
                    <th>상태</th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="tbody full scroll">
            <table>
                <caption>리스트내용</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead style="display: none;">
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="water in waterQualitySortList">
                        <td>{{ water.val4 }}</td>
                        <td>{{ water.val9 }}</td>
                        <td>{{ water.val8 }}</td>
                        <td>{{ water.val7 }}</td>
                        <td>{{ getLevel(water) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";

export default {
    computed: {
        ...mapGetters({
            waterQualityList: 'getWaterQualityList',
            seoulHjdCodeList: 'getSeoulHjdCodeList',
        }),
        waterQualitySortList(){
            let codeMap = gripUtil.toDict(this.seoulHjdCodeList, 'commonCode');
            let list = [];
            this.waterQualityList.forEach((d)=>{
                let seq = '';
                if(!!codeMap[d.val2]) {
                    seq = codeMap[d.val2].seq;
                } else {
                    seq = '1123074';
                }
                d.seq = seq;
                list.push(d);
            });
            list.sort((first, second)=>{
                return Number(first.seq) - Number(second.seq);
            });
            return list;
        },
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        basdtVal(){
            if(this.waterQualitySortList.length > 0) {
                let basdtVal = this.waterQualitySortList[0].basdtVal;
                return gripUtil.formatDate(basdtVal, 'yyyy-MM-dd HH:mm') + ' 기준';
            }
            return '';
        },
    },
    methods: {
        getLevel(waterInfo){
            return airLevel.waterAllQuality(waterInfo)[1];
        },
    },
};
</script>
